import Vue from 'vue';
import SavingsCalculator from './SavingsCalculator';

Vue.component('savings-calculator', SavingsCalculator);
